export const VerificationStatusEnum = {
  Manual: 'M',
  Excluded: 'X',
  SelectedNotCompleted: 'S',
  DeclinedUnderDeclineToVerify: 'D',
  AllStudentsSetToWithdrawn: '1',
  NoChange: '2',
  DecreaseBenefitsFreeToReduced: '3',
  DeniedOverIncome: '4',
  DeniedCaseNumberNotVerified: '5',
  IncreaseBenefitsReducedToFreeIncome: '6',
  IncreaseBenefitsReducedToFreeCategorical: '7',
  DeniedIncomplete: '8',
  NoResponse: '9',
  HouseholdDeclinedBenefits: 'H',
  DirectlyVerified: 'V',
  None: '0',
};

export const ExcludedVerificationStatuses = [
  VerificationStatusEnum.Manual,
  VerificationStatusEnum.Excluded,
  VerificationStatusEnum.None,
  VerificationStatusEnum.DeclinedUnderDeclineToVerify,
];

export const VerificationStatusesAllowingDelete = [
  VerificationStatusEnum.Manual,
  VerificationStatusEnum.Excluded,
  VerificationStatusEnum.None,
];



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/VerificationStatusEnum.js